import React from "react";
import { Link } from "react-router-dom";
import { FaPeopleGroup, FaChild, FaPersonDress, FaHouseFloodWater } from "react-icons/fa6";

const KonsentrasiPemberdayaan: React.FC = () => {
  const IconGrup = FaPeopleGroup as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconChild = FaChild as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconPerson = FaPersonDress as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconHouse = FaHouseFloodWater as React.FC<React.SVGProps<SVGSVGElement>>;

  const data = [
    {
      title: "Kemiskinan",
      desc: "Pemberdayaan ekonomi masyarakat untuk meningkatkan kemandirian dan kesejahteraan.",
      Icon: IconGrup,
      link: "/program/kemiskinan",
    },
    {
      title: "Yatim & Dhuafa",
      desc: "Dukungan pendidikan, kesehatan, dan kebutuhan dasar bagi anak-anak dan keluarga rentan.",
      Icon: IconChild,
      link: "/program/yatim-dhuafa",
    },
    {
      title: "Janda",
      desc: "Program penguatan peran dan ekonomi bagi perempuan kepala keluarga.",
      Icon: IconPerson,
      link: "/program/janda",
    },
    {
      title: "Bencana Alam",
      desc: "Respon cepat, bantuan darurat, dan pemulihan pascabencana.",
      Icon: IconHouse,
      link: "/program/bencana-alam",
    },
  ];

  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Title */}
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
            Konsentrasi <span className="text-red-600 font-bilbo">Pemberdayaan</span>
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">Fokus program pemberdayaan yang dijalankan untuk menjawab berbagai tantangan sosial di masyarakat.</p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {data.map((item, index) => {
            const Icon = item.Icon;
            return (
              <Link
                key={index}
                to={item.link}
                className="group bg-white border border-gray-200 rounded-2xl p-6
                           transition-all duration-300 hover:-translate-y-2
                           hover:border-red-600 hover:shadow-xl">
                {/* Icon */}
                <div
                  className="w-14 h-14 flex items-center justify-center rounded-xl
                             bg-red-50 text-red-600 transition
                             group-hover:bg-red-600 group-hover:text-white">
                  <Icon className="w-8 h-8" />
                </div>

                {/* Content */}
                <h3 className="mt-6 text-xl font-bold text-gray-900 group-hover:text-red-600 transition">{item.title}</h3>

                <p className="mt-3 text-gray-600 text-sm leading-relaxed">{item.desc}</p>

                <span className="inline-block mt-6 text-sm font-semibold text-red-600 group-hover:underline">Lihat Program →</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default KonsentrasiPemberdayaan;
